module.exports = __webpack_public_path__ + "img/singpass-logo-large.5fb02291.png";